const contactInfo = [
  {
    icon: "ri-map-pin-line",
    label: "Address",
    value: "Ortijes bb",
  },
  {
    icon: "ri-building-line",
    label: "City",
    value: "Mostar",
  },
  {
    icon: "ri-mail-open-line",
    label: "ZIP Code",
    value: "88000",
  },
  {
    icon: "ri-global-line",
    label: "Country",
    value: "Bosnia and Herzegovina",
  },
  {
    icon: "ri-mail-line",
    label: "Email",
    value: "information@formodoo.net",
  },
  {
    icon: "ri-phone-line",
    label: "Phone",
    value: "+1 6066980970",
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-28 md:py-36 px-6 md:px-12 lg:px-20 bg-[#1C1C1E]">
      <div className="max-w-7xl mx-auto">
        {/* Top Row */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-20 gap-4">
          <div className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/e9fcafd3-bf85-4c95-b4ca-0c9e01920a48.png"
              alt="FORMO d.o.o. logo"
              className="h-8 w-auto object-contain"
            />
            <span className="text-white font-semibold text-lg tracking-tight">FORMO d.o.o.</span>
          </div>
          <p className="text-sm text-gray-500 md:text-right">
            Modern iOS Development Excellence
          </p>
        </div>

        {/* Main Content */}
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">
          {/* Left: Image + Tagline */}
          <div className="flex flex-col gap-8 flex-1">
            <div className="w-full h-52 rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/40e8850cff9c65f8df5ce6e5c25f7eeb.jpg"
                alt="FORMO d.o.o. iOS development"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <p className="text-3xl md:text-4xl font-light text-white leading-snug">
                Building
                <br />
                Tomorrow&apos;s
                <br />
                Applications
              </p>
              <p className="mt-6 text-sm text-gray-500 leading-relaxed max-w-sm">
                We are always open to new partnerships, collaborations, and conversations. Reach out to us — we&apos;d love to hear from you.
              </p>
            </div>
          </div>

          {/* Right: Contact Info */}
          <div className="flex-1">
            <span className="block text-xs uppercase tracking-widest text-gray-500 font-medium mb-8">
              Get in Touch
            </span>
            <div className="flex flex-col gap-6">
              {contactInfo.map((item) => (
                <div key={item.label} className="flex items-start gap-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/5 flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-gray-400 text-base`} />
                  </div>
                  <div>
                    <span className="block text-xs uppercase tracking-widest text-gray-500 font-medium mb-1">
                      {item.label}
                    </span>
                    <span className="text-sm text-white font-medium">{item.value}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-600">
            &copy; {new Date().getFullYear()} FORMO d.o.o. All rights reserved.
          </p>
          <p className="text-xs text-gray-600">
            iOS Application Development &mdash; Mostar, Bosnia and Herzegovina
          </p>
        </div>
      </div>
    </section>
  );
}
